module.exports = __webpack_public_path__ + "static/media/img112_R.eeb89618.jpg";